import { render, staticRenderFns } from "./_base-title.vue?vue&type=template&id=61ac0eeb"
var script = {}
import style0 from "./_base-title.vue?vue&type=style&index=0&id=61ac0eeb&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports